//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters } from 'vuex';
import recommendationAudioPlayer from '@motionelements/core/src/components/mixins/recommendationAudioPlayer.mixin.js';

export default {
  name: 'preview-large',
  mixins: [recommendationAudioPlayer],
  components: {
    // 'viewport-helper': () => import('@/components/modules/common/ViewportHelper.vue'),
    PlayerVideo: () => import('./players/PlayerVideo.vue'),
    MusicRecommendDesktop: () => import('./recommend/MusicRecommend.Desktop.vue'),
    MusicRecommendMobile: () => import('./recommend/MusicRecommend.Mobile.vue'),
  },
  props: {
    element: {
      type: Object,
      required: true,
    },
    recommendedMusicElements: {
      type: Array,
      required: false,
    },
    showRecommendedMusic: {
      type: Boolean,
      default: true,
    },
  },
  mounted() {
  },
  computed: {
    ...mapState({
      windowWidth: state => state.browser.window.width,
    }),
    ...mapGetters({
      videoPlayerStatus: 'videoPlayer/playerStatus',
      currentSoundId: 'productRecommendationAudio/currentSoundId',
    }),
    hasRecommendedMusic() {
      return this.recommendedMusicElements && this.recommendedMusicElements.length;
    },
    hasVideoPreview() {
      return !!_.get(this.element, 'previews.mp4.url');
    },
    imagePreview() {
      return _.get(this.element, 'previews.jpg.url');
    },
  },
  watch: {
    'videoPlayerStatus.pause'() {
      if (this.videoPlayerStatus.pause) {
        this.doAudioPlayerReset();
      }
      if (!this.currentSoundId) {
        this.$videoPlayer.volume(1);
      }
    },
  },
  methods: {
    onClickPlayRecommendMusic(element) {
      console.log('onClickPlayRecommendMusic: ', element);
      // when click current playing element, it should stop video and music
      let elementId = '';
      if (element) {
        elementId = _.get(element, 'id');
      }
      const isClickedSameItem = this.currentSoundId === elementId;

      // if click same music, playing will stop
      if (isClickedSameItem && element) {
        this.$videoPlayer.pause();
        this.$videoPlayer.volume(1);
        this.doAudioPlayerReset();
        return;
      }

      this.doAudioPlayerStopAll();

      // use video audio track when click default track
      if (!element) {
        // this volume need before play
        this.$videoPlayer.volume(1);
        this.$videoPlayer.play();
        this.$videoPlayer.seek(0);
        // need reset audio play before pause, to prevent audio resume
        this.doAudioPlayerReset();
      } else {
        this.$videoPlayer.play();
        this.$videoPlayer.seek(0);
        this.$videoPlayer.volume(0);
        this.$videoPlayer.muted(true);
        this.clickAudioPlayButton(element);
      }
    },
  },
};
